module.exports = __webpack_public_path__ + "img/instructor_img1.d55ef64c.png";